import { Modal } from "@seneca/senekit";

import { SignUpCard } from "features/sign-up/common-routes/components/Layout";

import SignUpCardContainer from "./containers/SignUpCardAppsContainer";

type Props = {
  linkToSignIn: string;
  linkToNextPage?: string;
  linkToNextPageSSO?: string;
  redirectAuthenticatedUserTo?: string;
  accountType?: string;
  frontdoor?: boolean;
  modalProps: {
    partOfJourney: boolean;
    fullscreenOnMobile: boolean;
    onCloseClick?: () => void;
  };
};

export default function SignUpFirstStage({ modalProps, ...props }: Props) {
  if (props.frontdoor) {
    return (
      <SignUpCard>
        <SignUpCardContainer {...props} />
      </SignUpCard>
    );
  }

  return (
    <Modal maxWidth="medium" {...modalProps}>
      <SignUpCardContainer {...props} />
    </Modal>
  );
}
